import React from 'react';
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, message, Button, Divider,Select} from 'antd';
import { route } from '../../routes/routes';
import storage from '../../utils/storage';
import { configs } from '../../config/config';

import {dbFields}  from '../../model/role/column';
import { GetRoleList } from '../../model/role/requests';
import { BindRole, getGroup } from '../../model/group/requests';
export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};

export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};

const Option = Select.Option;


class GroupRole extends React.Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            roleList:[],
            roleIds:[],
            groupInfo:{},
            role_id:"",
            roles:{}
        }
    };

    componentDidMount(){
        let roleList = [];
        GetRoleList().then(res=>{
            if(res.data.code == 200){
                roleList = res.data.data
                this.setState({
                    roleList:roleList
                })
            }else{
                message.error(res.data.msg)
            }

        }).catch(err=>{
            message.error(err)
        })
    
        let id = this.props.match.params.id;
        let groupInfo = {}
        let roles = {}
        let role_id = ""
        getGroup({id:id}).then(res=>{
            if(res.data.code === 200 ){
                groupInfo = res.data.data

                if(groupInfo.roles.length >0){
                    roles = groupInfo.roles[0]
                    role_id = roles.name
                }
                this.formRef.current.setFieldsValue(roles);
                this.setState({
                    groupInfo:groupInfo,
                    roles:roles,
                    role_id:role_id
                })
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    handlerSubmit = (e)=>{
        let groupId = parseInt(this.props.match.params.id);
        let roleIds = this.state.roleIds;
        if(roleIds === 0){
            message.error("Please Chosen A Role")
            return false
        }
        let role_id = []
        role_id.push(roleIds)
        roleIds = role_id.join(",")
       BindRole({group_id:groupId,role_ids:roleIds}).then(res=>{

        if(res.data.code == 200){
            message.success("group binding role success !");
            setTimeout(()=>{
                storage.clear()
                this.props.history.push(configs.default.route)
            },1000)
        }else{
            message.error(res.data.msg)
        }
       }).catch(err=>{
        message.error(err)
       })

        return false;
    }

    handlerChange = (item) => {
        this.setState({
            roleIds:item
        })
    }
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }
    render(){
        const {roleList,roles} = this.state
        return (
            <>
              <BreadcrumbCustomer first='Group' second='Bind Role' />
                <Divider />
                <Form
                    ref={this.formRef}
                    {...layout}
                    initialValues={{
                        name:roles.id
                    }}
                    >
                    <Form.Item label={dbFields.id.title} name={dbFields.id.key}>
                        <Select 
                            onChange={this.handlerChange}
                        >
                            {roleList.length > 0  && roleList.map((items) => {
                                return (<Option key={items.id} value={items.id}> {items.name} </Option>)
                            })}
                        </Select>
                    </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                span: 12,
                                offset: 6,
                              }}
                        >
                            <Button 
                                type="primary" 
                                onClick = {this.handlerSubmit}
                            >
                                Submit
                            </Button>
                        </Form.Item>    

                </Form>    
            
            </>

        )
    }


}
export default  GroupRole;
